const riot = require('riot');
import './route.tag';
riot.tag2('target_site', '<div class="card is-collapse"> <header class="card-header"> <p class="card-header-title {has-text-grey:!expanded}" onclick="{toggleExpanded}"> {site.name} </p> <p class="card-header-icon"> <span if="{target.dtstart}">{toDay(target.dtstart)} - {toDay(target.dtend)}</span> <button if="{!isAutomated && expanded}" class="button is-small" onclick="{removeSite}">Remove site</button> &nbsp;&nbsp; <a href="#" onclick="{toggleExpanded}" aria-label="more options"> <span class="icon"> <i class="fas {fa-angle-down:!expanded,fa-angle-up:expanded}" aria-hidden="true"></i> </span> </a> </p> </header> <div if="{expanded}" class="card-content has-background-white-bis" style="margin-bottom:0.5rem"> <div class="columns"> <div class="column"> <div class="field control"> <label for="aliases" class="label">Aliases</label> </div> <div class="field control"> <textarea if="{!isAutomated}" class="textarea" name="aliases" ref="aliases" onchange="{setAliases}">{(target.aliases || []).join(\'\\n\')}</textarea> <div if="{isAutomated}" class="tags"> <span class="tag" each="{ali in target.aliases}">{ali}</span> </div> </div> </div> <div if="{!isAutomated}" class="column"> <div class="field control is-grouped"> <label for="parameters" class="label">Parameters</label> &nbsp;&nbsp;&nbsp; <div class="select control is-small"> <select name="new_parameter_mode" ref="new_parameter_mode" onchange="{setParameterMode}"> <option each="{parameter_modes}" riot-value="{idx}" selected="{idx == target.parameter_mode}">{name}</option> </select> </div> <div class="control"> <input type="checkbox" name="ignore_path" onchange="{setIgnorePath}" id="ignore_path" ref="ignore_path" class="switch is-info" checked="{target.ignore_path}"><label for="ignore_path">ignore path</label> </div> </div> <div class="field control"> <textarea class="textarea" name="parameters" ref="parameters" onchange="{setParameters}">{(target.parameters || []).join(\'\\n\')}</textarea> </div> </div> </div> <div class="field control"> <label for="new_route" class="label">Routes</label> <div if="{!isAutomated}" class="field is-grouped is-flexwrap"> <div class="control"> <input class="input is-small" ref="new_name" placeholder="Route name"> </div> <div class="control"> <input class="input is-small" ref="new_route" placeholder="URL pattern"> </div> <div class="control"> <input class="input is-small" ref="new_xpath" placeholder="Insertion point"> </div> <div class="control"> <button class="button is-light is-small" onclick="{addRoute}">Add route</button> </div> </div> <route each="{route, id in target.routes}"></route> </div> </div> </div>', '', '', function(opts) {


		const self = this;

		self.expanded = false;

		self.isAutomated  = self.parent.campaign.isAutomated
		self.templates = self.parent.templates

		{
			self.parameter_modes = [{
				idx: 'include',
				name: 'Keep only listed'
			}, {
				idx: 'exclude',
				name: 'Keep All but listed'
			}];
		}

    this.toDay = function(date) {
      var d = new Date(date)
      return [d.getFullYear(),('0'+(1+d.getMonth())).slice(-2),('0'+d.getDate()).slice(-2)].join('-')
    }.bind(this)

		this.removeSite = function(e) {
			self.parent.removeSite(e);
			e.preventUpdate = true;
		}.bind(this)
		this.toggleExpanded = function(e) {
			e.preventDefault();
			self.expanded = !self.expanded;
		}.bind(this)
		this.setParameterMode = function(e) {
			e.preventDefault();
			self.target.parameter_mode = self.refs.new_parameter_mode.value;
		}.bind(this)
		this.setAliases = function(e) {
			e.preventDefault();
			self.target.aliases = self.refs.aliases.value.split(/[\s,]/g);
		}.bind(this)
		this.setIgnorePath = function(e) {
			e.preventDefault();
			self.target.ignore_path = self.refs.ignore_path.checked;
		}.bind(this)
		this.setParameters = function(e) {
			e.preventDefault();
			self.target.parameters = self.refs.parameters.value.split(/[,\s\n]/g);
		}.bind(this)
		this.addRoute = function(e) {
			e.preventDefault();

			let widget = {
				name: self.refs.new_name.value,
				data: {
					count: 0,
					min_count: 0,
					img_width: 0,
					img_height: 0
				},
				template: '',
				encoding: '',
				path: self.refs.new_route.value,
				xpath: self.refs.new_xpath.value,
				segments: [],
				time_limit: {
					mode: 'disable',
					intervals: []
				},
				capping: {},
				immediate_load: false
			}

			let route = {
				name: widget.name,
				widget: widget
			}

			self.target.routes.push(route);
			self.update();
		}.bind(this)
		this.removeRoute = function(e) {
			e.preventDefault();

			self.target.routes.splice(e.item.id, 1);
			self.update();
		}.bind(this)
});
